import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-fin-inst',
  templateUrl: './default-fin-inst.component.html',
  styleUrls: ['./default-fin-inst.component.css']
})
export class DefaultFinInstComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
